"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _createSvg = require("../createSvg");

var _interfaces = require("../interfaces");

var _default = (0, _createSvg.createSvg)('IconUpload', new _interfaces.SVGIconWithSizes((0, _defineProperty2.default)({}, _interfaces.IconSize.Small, {
  paths: ['M16,15.9987 C16.553,15.9987 17,16.4457 17,16.9987 L17,18.9987 C17,19.5517 16.553,19.9987 16,19.9987 L4,19.9987 C3.447,19.9987 3,19.5517 3,18.9987 L3,16.9987 C3,16.4457 3.447,15.9987 4,15.9987 C4.553,15.9987 5,16.4457 5,16.9987 L5,17.9987 L15,17.9987 L15,16.9987 C15,16.4457 15.447,15.9987 16,15.9987 Z M6.707,5.7057 C6.316,6.0967 5.684,6.0967 5.293,5.7057 C4.902,5.3147 4.902,4.6827 5.293,4.2917 L9.292,0.2927 C9.384,0.1997 9.495,0.1267 9.618,0.0757 C9.862,-0.0253 10.138,-0.0253 10.382,0.0757 C10.505,0.1267 10.616,0.1997 10.708,0.2927 L14.707,4.2917 C15.098,4.6827 15.098,5.3147 14.707,5.7057 C14.512,5.9007 14.256,5.9987 14,5.9987 C13.744,5.9987 13.488,5.9007 13.293,5.7057 L11,3.4127 L11,14.9987 C11,15.5517 10.553,15.9987 10,15.9987 C9.447,15.9987 9,15.5517 9,14.9987 L9,3.4127 L6.707,5.7057 Z'],
  params: {
    width: '20',
    height: '20'
  },
  height: 20,
  width: 20
})));

exports.default = _default;